module.exports = __webpack_public_path__ + "img/primary-template.7c7c130c.svg";